import { render, staticRenderFns } from "./createOurService.vue?vue&type=template&id=656efef3&"
import script from "./createOurService.vue?vue&type=script&lang=js&"
export * from "./createOurService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports